import { css, SerializedStyles } from '@emotion/react';

// Static styles
export const DEAL_BUTTON_STATIC_STYLES: SerializedStyles = css`
    &.rdp-day_button[data-deal-button] {
        --date-picker-deal-color: var(--dpdb-color-deal-color);
        --date-picker-deal-background: var(--dpdb-color-deal-background-color);

        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: flex-start;
        gap: 2px;
        height: auto;
        padding: calc(var(--hc-spacing-unit) * 2) 0;
        position: relative;

        [data-deal-price] {
            font-size: 0.75rem;
            line-height: 1;
            font-weight: var(--hc-body-font-weight-default);
        }

        [data-deal-callout] {
            font-size: 0.563rem; // 9px
            line-height: 0.9;
            font-family: var(--hc-hero-font-family);
            color: var(--hc-color-common-white);
            background-color: var(--date-picker-deal-color);
            border-radius: 2px;
            padding: 2px 8px;
            position: absolute;
            top: -6px;
        }

        &[data-highlighted] {
            background-color: var(--date-picker-selected-range-background);
            color: var(--date-picker-selected-range-text);
        }

        &[data-deal] {
            border: solid 2px var(--date-picker-deal-color) !important;
            background-color: var(--date-picker-deal-background);
        }

        &[data-highlighted] {
            background-color: var(--date-picker-selected-range-background);
            color: var(--date-picker-selected-range-text);
        }

        &[data-selected] {
            background-color: var(--date-picker-selected-day-background);
            color: var(--date-picker-selected-day-text);
        }
    }
`;
